const React = require("react");
const ReactDOM = require("react-dom");
const ReactMarkdown = require("react-markdown");

const input = "# This is a header\n\nAnd this is a paragraph";

const MdTemplate = props => {
  const { mdString } = props;
  return <ReactMarkdown source={props.mdString} />;
};

export default MdTemplate;
